import { SELECT, execute , UPDATE , INSERT } from "@/utils/database_module"
import { availableName } from "@/utils/fncts";
import { Conflict, ConflictData, ConflictHistory, ConflictStatus, Order, Product, User } from "@/utils/types"
import { stat } from "fs";
import moment from "moment";
import { Message } from "postcss";


const conflicts = {
    getAll : async (filter : Filter , user_id? : number) => {
        const { searchQuery, selectedStatus, startDate, endDate, limit,  order } = filter;
        
        const statusStr = Array.isArray(selectedStatus)
        ? `AND (${selectedStatus.map(status => `c.status = ${status}`).join(" OR ")})`
        : selectedStatus && selectedStatus !== 0 
          ? `AND c.status = ${selectedStatus}` 
          : "";
        
        const limitStr = limit ? `LIMIT ${limit}` : "";
        const orderStr = order && order != "" ? `ORDER BY ${order}` : 'ORDER BY c.date DESC'
    
        const query = `SELECT * FROM conflicts c WHERE is_deleted=0 ${statusStr} ${orderStr} ${limitStr} `;
        const conflicts = (await execute( query  )) as Conflict[];
        const conflictsOrdersIds =  conflicts.map(conflict => conflict.order_id).join(", ");
        const orders = conflictsOrdersIds ?  await execute(`SELECT * FROM orders WHERE id IN (${conflictsOrdersIds})`) as Order[] : [];
        const ordersUsersIds = orders.map(order => order?.user_id).join(", ")    
        const users = ordersUsersIds ?await execute(`SELECT id, first_name, last_name, email, phone_numbers, profile_pic,token, adress FROM users WHERE role = 'user' AND id IN (${ordersUsersIds}) `) as any[]     :[];
   
        
        for (const user of users) {
            user.phone_numbers = typeof user.phone_numbers == 'string'? JSON.parse(`${user.phone_numbers}`)   : user.phone_numbers
        }
    
        const ordersProductIds = orders.map(order => order.product_id).join(", ");
        const products =ordersProductIds ? await execute(`SELECT id, name, images FROM products WHERE id IN (${ordersProductIds})`) as Product[] : [];
        for (const product of products) {
            product.name = typeof product.name == 'string' ? JSON.parse(`${product.name}`): product.name
        }
    
        const conflictStatuses =  (await SELECT(`conflict_status`, { isIndexed: true, })) as ConflictStatus[];
    
        for (const conflict of  conflicts) {
            conflict.status = conflictStatuses[conflict.status as number] ;
            
            const userId = orders.find(order => order.id === conflict.order_id)?.user_id;
            conflict.user = users.find(user => user.id === userId);
    
            const productId = orders.find(order => order.id === conflict.order_id)?.product_id;
            const product = products.find(product => product.id === productId);
    
            if (product){
                conflict.product = product;
                conflict.product.images = typeof product.images == 'string' ? JSON.parse(`${product.images}`) : ["image-placeholder.png"];
            }
    
        }
        const filteredConflicts =  conflicts.filter((conflict) => {
          const filterByType = conflict?.type.toLocaleLowerCase().includes(searchQuery?.toLocaleLowerCase() ?? "")
          const filterByProductsName = JSON.stringify(conflict?.product?.name)?.toLocaleLowerCase().includes(searchQuery?.toLocaleLowerCase() ?? "")
          const filterByUserName = conflict?.user?.first_name.toLocaleLowerCase().includes(searchQuery?.toLocaleLowerCase() ?? "") || conflict?.user?.last_name.toLocaleLowerCase().includes(searchQuery?.toLocaleLowerCase() ?? "")
          
          const filterByStartDate = startDate && !moment(moment(conflict.date).format("YYYY-MM-DD")).isSameOrAfter( moment(startDate).format("YYYY-MM-DD") ) ? false : true;
          const filterByEndDate = endDate && !moment(moment(conflict.date).format("YYYY-MM-DD")).isSameOrBefore( moment(endDate).format("YYYY-MM-DD") ) ? false : true;
          
          if ((filterByType || filterByUserName || filterByProductsName) && filterByStartDate &&  filterByEndDate ) return true;
            return false;
          });    

        return filteredConflicts
    },

    getUserConflicts : async (user_id : number , filter : Filter) => {
        const {  selectedStatus, startDate, endDate,} = filter;
        const orders = (await SELECT("orders", { conditions: [ { column: "user_id", operator: "=", value: parseInt(`${user_id}`)}]})) as Order[];
       
        const orderIds = orders.map((order) => order.id).join(", ");
        let selectedStatusStr = !isNaN(selectedStatus) && parseInt(`${selectedStatus}`) != 0 ? ` AND status = ${parseInt(`${selectedStatus}`)} ` : "";
       
        const conflicts =orderIds ? (await execute(`SELECT * FROM conflicts WHERE is_deleted=0 AND order_id IN (${orderIds}) ${selectedStatusStr} ORDER BY date DESC `)) as Conflict[] : [] ;
        
        const filteredOrdersProductsIds = orders.filter((order) => conflicts.some((conflict) => conflict.order_id === order.id) ).map((o)=> o.product_id).join(", ")
            const products = filteredOrdersProductsIds ? await execute(`SELECT id, name, images FROM products WHERE id IN (${filteredOrdersProductsIds})`) as Product[] : [];
    
        const conflictStatuses =  (await SELECT(`conflict_status`, { isIndexed: true, })) as ConflictStatus[];
    
        for (const conflict of  conflicts) {
            conflict.status = conflictStatuses[conflict.status as number] ;
            
            const productId = orders.find(order => order.id === conflict.order_id)?.product_id;
            const product = products.find(product => product.id === productId);
    
            if (product){
                conflict.product = product;
                conflict.product.images = typeof product.images == 'string' ? JSON.parse(`${product.images}`) : ["image-placeholder.png"];
            }
    
        }
    
        const filteredConflicts =  conflicts.filter((conflict) => {
            const filterByStartDate = startDate && !moment(moment(conflict.date).format("YYYY-MM-DD")).isSameOrAfter( moment(startDate).format("YYYY-MM-DD") ) ? false : true;
            const filterByEndDate = endDate && !moment(moment(conflict.date).format("YYYY-MM-DD")).isSameOrBefore( moment(endDate).format("YYYY-MM-DD") ) ? false : true;
            
            if ( filterByStartDate &&  filterByEndDate ) return true;
              return false;
        });   
        return filteredConflicts
        
    },
    
    update : async (id : number , conflict : { status : number , details : string , history : ConflictHistory}) => {
        const { status , details , history } = conflict
        await UPDATE("conflicts" , { status : status , details : details } , [{column : "id" , operator : "=" , value : id}])
        
        const [newStatus] = await SELECT("conflict_status" , { conditions : [{column : "id" , operator : "=" , value : status }]}) as ConflictStatus[]
        await INSERT("conflicts_history" , { conflict_id : id , user_id : history.user_id , action : history.action , details : {...history.details , new_status : newStatus} })
    },
    
    insert : async (data : ConflictData & Message) => {
        const conflictToAdd = { type: data.type, order_id: data.order_id, date: data.date, status: data.status,}
        const conflict = await INSERT("conflicts" , conflictToAdd)
        await INSERT("chat_messages" , {
            message: data.message,
            image: data.image,
            chat_id: `${conflict.id}`,
            is_conflict : 1,
            sender_id: data.sender_id,
            user_id : data.user_id
        });
        await INSERT("conflicts_history" , {
            conflict_id: conflict.id,
            user_id: data.user_id,
            action: "Création du conflit",
            date: moment().format("YYYY-MM-DD HH:mm:ss"),
        });
        return conflict

    },

    getHistory : async (id : number) => {
        const history = await SELECT("conflicts_history" , { conditions : [{column : "conflict_id" , operator : "=" , value : id }] }) as ConflictHistory[];
        
        const usersIds = history.map((data) => data.user_id);
        const users = usersIds.length>0 ? await execute( `SELECT first_name , last_name , role ,profile_pic,email, token, id FROM users WHERE id IN (${usersIds.join(",")})`) as User[]: [] as User[];
        
        for (let i = 0; i < history.length; i++) {
            const historyItem = history[i];
            const user = users?.find((user) => user.id == historyItem.user_id);
            history[i] = {...historyItem , user : user}
        }
       
        return history
    },

    delete : async (id : number) => {
        return await UPDATE("conflicts" , { is_deleted : 1 } , [{column : "id" , operator : "=" , value : id}])
    }

}

export default conflicts



type Filter = {
    startDate?: string;
    endDate?: string;
    selectedStatus?: any ;
    searchQuery?: string;
    limit?: number;
    order?: string;
  };